export default "__VITE_ASSET__D5vFp4Oh__"